<template>

  <div class="api-info-section" :style="{
    'padding-left': $screen.breakpoint != 'sm' ? '2%' : '0',
    'margin-top': $screen.breakpoint != 'sm' ? '' : '0px'
    }" id="info-section" ref="anchor">
    <div class="api-feed">
      <div class="scroll-marker" id="scroll-anchor"></div>
      <section v-for="sub in section.subsections">
        <h3 class="api-feed-sec-header" :style="{'padding-left': $screen.breakpoint != 'sm' ? '' : '1%'}">{{sub.title}}<img v-if="sub.icon":src="sub.icon"/></h3>
        <div v-for="c in sub.content" class="content-sec">
          <p v-if="c.tag == 'p'" v-html="c.content" :style="{'padding-left': $screen.breakpoint != 'sm' ? '' : '1%'}"></p>
          <p v-if="c.tag == 'highlight'" :style="{'padding-left': $screen.breakpoint != 'sm' ? '' : '1%'}"><b>{{c.content}}</b></p>
          <pre v-if="c.tag == 'example'" class="code-block wide-block" v-html="c.content" :style="{'font-size': $screen.breakpoint == 'sm' ? '.9em' : ''}"></pre>
          <div class="api-sec-img-container" v-if="c.tag == 'code'">
            <pre v-html="c.content" class="code-block" :style="{'font-size': $screen.breakpoint == 'sm' ? '.9em' : ''}"><code v-html="c.content"></code></pre>
          </div>
          <ul v-if="c.tag == 'ul'" :style="{'padding-left': $screen.breakpoint != 'sm' ? '' : '1%'}">
            <li v-for="item in c.content" v-html="item">
            </li>
          </ul>
          <ol v-if="c.tag == 'ol'" :style="{'padding-left': $screen.breakpoint != 'sm' ? '' : '1%'}">
            <li v-for="item in c.content" v-html="item">
            </li>
          </ol>
          <div class="api-sec-img-container" v-if="c.tag == 'img'">
            <img :src="getLocalImg(c.content)" class="api-sec-img"/>
          </div>
          <table v-if="c.tag == 'thresh'" class="thresh-table">
            <thead>
              <tr>
                <th v-for="(head, hIndex) in threshHeads" v-if="$screen.breakpoint == 'lg' || [0, 5, 6, 7].includes(hIndex)" :style="{'font-size': $screen.breakpoint == 'lg' ? '' : '.8em'}">{{head}}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="rdg in c.content">
                <td v-for="(val, tIndex) in threshHeads" v-if="$screen.breakpoint == 'lg' || [0, 5, 6, 7].includes(tIndex)" :style="{'font-size': $screen.breakpoint == 'lg' ? '' : '.8em'}">
                  {{rdg[Object.keys(rdg)[tIndex]]}}
                </td>
                <!-- <td v-for="rdg in c.content">{{}}</td> -->
              </tr>
            </tbody>
          </table>
          <div  v-if="c.tag == 'compat'" class="api-sec-img-container" style="flex-direction:column;">
            <h4 v-html="c.label" style="text-align:center;margin-bottom:5px;"></h4>
            <div class="compat-table">
              <div v-for="pList in c.content" class="compat-row" :style="{'height': `${Math.round(375/pList.length)}px`}">
                <div v-for="p in pList" class="compat-item" :style="{'width': `${Math.round(375/pList.length) - 2}px`}">
                  <h6 v-if="p.tag == 'txt'" style="font-weight:.8em;">{{p.val}}</h6>
                  <div v-else class="compat-fill" :style="{'background': p.val}"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="api-sec-img-container" v-if="c.tag == 'png'">
            <h5 v-html="c.label" style="text-decoration:underline;"></h5>
            <img :src="getLocalImg(c.content, true)" class="api-sec-img"/>
          </div>
        </div>
      </section>
    </div>
  </div>

</template>

<script type="text/javascript">

import VueScrollTo from 'vue-scrollto';

export default {
  data(){
    return {
      threshHeads: [
        'Reading',
        'Units',
        'Abbreviation',
        'Minimum Value',
        'Maximum Value',
        'Good Range',
        'Warning Range',
        'Critical Range',
        'Warning Range 2',
        'Critical Range 2'
      ]
    }
  },
  filters: {
    pretty: function(v){
      return JSON.stringify(JSON.parse(v), null, 1)
    }
  },
  computed: {
    section: function(){
      return this.$store.getters.getActiveSection();
    }
  },
  methods: {
    getLocalImg(i, png){
      return require(`@/assets/${i}.${png ? 'png' : 'jpeg'}`);
    }
  },
  watch: {
    section: function(newData, oldData){
      const el = this.$refs.anchor;
      el.scrollTo(0, 0);
    }
  }
}

</script>

<style>

.api-info-section {
  width: 70%;
  min-width: 400px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  margin-top: 50px;
  overflow-x: hidden;
  overflow-y: scroll;
}

.api-feed {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin-bottom: 200px;
  overflow-x: hidden;
}

.api-feed ul, .api-feed ol, .api-feed li, .api-feed p {
  max-width: 95%;
}

.api-feed-sec-header {
  color: rgb(53, 159, 177);
  height: 25px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.api-feed-sec-header img {
  height: 100%;
  margin-left: 10px;
}

.api-sec-img-container {
  width: 95%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 0px;
}

.api-sec-img {
  max-height: 400px;
  max-width: 90%;
}

code {
  background-color: #eee;
  border: 1px solid #999;
  display: block;
  padding: 20px;
}

.code-block {
  width: 85%;
  max-width: 92%;
  padding: 10px;
  color: lightblue;
  background: gray;
  font-size: 12pt;
  font-weight: 600;
  border-radius: 4px;
  line-height: 25px;
  white-space: pre-wrap;
}

.wide-block {
  width: auto;
  max-width: 92%;
  white-space: pre-wrap;
}

.thresh-table {
  border-collapse: collapse;
  margin: 25px 0;
  font-size: .9em;
  min-width: 400px;
  max-width: 95%;
  margin: 0px;
}

.thresh-table thead tr {
  background: #009879;
  color: white;
  text-align: center;
  font-weight: bold;
}

.thresh-table th {
  border-left: 2px solid rgb(212, 212, 222);
  border-right: 2px solid rgb(212, 212, 222);
}

.thresh-table th, .thresh-table td {
  padding: 12px 15px;
  text-align: center;
}

.thresh-table tbody tr {
  border-bottom: 1px solid darkgray;
}

.thresh-table tbody tr:nth-of-type(even){
  background-color: rgb(194, 194, 194);
}

.compat-table {
  width: 375px;
  height: 375px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: space-between;
  overflow: hidden;
}

.compat-row {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.compat-item {
  height: calc(100% - 2px);
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgb(83, 83, 83);
  color: white;
}

.compat-fill {
  width: 100%;
  height: 100%;
}

</style>



// WEBPACK FOOTER //
// src/components/api/Info.vue